import { render } from "./create_form.html?vue&type=template&id=483b29f6&external"
import script from "./create_form.js?vue&type=script&lang=js&external"
export * from "./create_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__